import React from "react";

interface SaveConfigModalProps {
  isOpen: boolean;
  configName: string;
  isDefault: boolean;
  saveMode: "update" | "new";
  isSaving: boolean;
  hasExistingConfig: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onConfigNameChange: (name: string) => void;
  onIsDefaultChange: (isDefault: boolean) => void;
  onSaveModeChange: (mode: "update" | "new") => void;
}

const SaveConfigModal: React.FC<SaveConfigModalProps> = ({
  isOpen,
  configName,
  isDefault,
  saveMode,
  isSaving,
  hasExistingConfig,
  onClose,
  onConfirm,
  onConfigNameChange,
  onIsDefaultChange,
  onSaveModeChange,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ height: "380px" }}>
          <div className="modal-header">
            <h5 className="modal-title">
              {saveMode === "update"
                ? "Update Dashboard Configuration"
                : "Save New Dashboard Configuration"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            {hasExistingConfig && (
              <div className="mb-3">
                <label className="form-label fw-semibold">Save Option</label>
                <div className="d-flex gap-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="saveMode"
                      id="saveModeUpdate"
                      checked={saveMode === "update"}
                      onChange={() => onSaveModeChange("update")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="saveModeUpdate">
                      Update existing
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="saveMode"
                      id="saveModeNew"
                      checked={saveMode === "new"}
                      onChange={() => onSaveModeChange("new")}
                    />
                    <label className="form-check-label" htmlFor="saveModeNew">
                      Save as new
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div className="mb-3">
              <label className="form-label fw-semibold">
                Configuration Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={configName}
                onChange={(e) => onConfigNameChange(e.target.value)}
                placeholder="e.g., Sales Dashboard, Executive View"
                autoFocus
              />
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="isDefaultCheck"
                checked={isDefault}
                onChange={(e) => onIsDefaultChange(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="isDefaultCheck">
                Set as default configuration
              </label>
              {isDefault && (
                <small className="text-muted d-block mt-1">
                  This will unset any existing default configuration
                </small>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary me-3"
              onClick={onClose}
              disabled={isSaving}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={!configName.trim() || isSaving}>
              {isSaving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" />
                  Saving...
                </>
              ) : saveMode === "update" ? (
                <>
                  <i className="ti ti-check me-1" />
                  Update Configuration
                </>
              ) : (
                <>
                  <i className="ti ti-plus me-1" />
                  Save as New
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveConfigModal;
